


















































































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import BankCardDialog from './BankCardDialog.vue'
import StatusBankCard from '@/components/common/StatusBankCard.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { translate, DateTime } from '@/utils/filters'
import { Form, FormType } from '@/api/model/DefaultPageEntity'
import { cardStatusMap } from '@/utils/status-map'

@Component({
    components: {
        SearchForm,
        TableForm,
        BankCardDialog,
        StatusBankCard
    }
})
export default class BankCard extends Vue {
    dateTime = DateTime
    searchForm = {
        current: 1,
        size: 10,
        realName: null,
        identity: null,
        phone: null,
        cardNo: null,
        status: null
    }
    cardStatusMap = cardStatusMap
    statusOptions = cardStatusMap.createArray()

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false
    copyShow = false
    formData = {}
    forms: Form[] = [
        { prop: 'sourceMerchantId', label: translate('payment.sourceMerchantId') as string, formType: FormType.INPUT },
        { prop: 'targetMerchantId', label: translate('payment.targetMerchantId') as string, formType: FormType.INPUT }
    ]
    form = { bankName: '' }

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }
    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.bankCardService
            .bankCardList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    // 增加
    create() {
        this.show = true
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    // 启用银行
    enable(row: any) {
        this.showDialog(translate('bank.isBatchEnable'), async () => {
            $Api.bankCardService
                .batchEnable({ req: row.id })
                .pipe(
                    finalize(() => {
                        this.getData()
                    })
                )
                .subscribe(data => {
                    this.$message.success('Success!')
                })
        })
    }

    // 停用银行
    disable(row: any) {
        this.showDialog(translate('bank.isBatchDisable'), async () => {
            $Api.bankCardService
                .batchProhibit({ req: row.id })
                .pipe(
                    finalize(() => {
                        this.getData()
                    })
                )
                .subscribe(data => {
                    this.$message.success('Success!')
                })
        })
    }

    // 弹出提示框
    showDialog(title: string, callback: Function) {
        this.$confirm(title, {
            confirmButtonText: this.$t('common.btn.confirm') as string,
            cancelButtonText: this.$t('common.btn.cancel') as string,
            type: 'warning'
        })
            .then(() => {
                callback()
            })
            .catch(() => {})
    }

    created() {
        this.getData()
    }
    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }
}
